var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOutline = function SvgOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.875 13.646v-1.458h1.667V6.562c0-1.097.35-2.103 1.052-3.02a4.704 4.704 0 0 1 2.739-1.771V.042h2.334v1.75a4.55 4.55 0 0 1 2.729 1.76c.695.924 1.042 1.927 1.042 3.01v5.626h1.687v1.458H.875ZM7.5 16.562c-.445 0-.823-.149-1.135-.447-.313-.299-.469-.684-.469-1.157h3.208c0 .473-.15.858-.448 1.157-.299.298-.684.447-1.156.447ZM4 12.188h6.979V6.562c0-.958-.333-1.777-1-2.458-.667-.68-1.493-1.021-2.479-1.021-.959 0-1.782.34-2.469 1.021C4.344 4.784 4 5.604 4 6.562v5.626Z",
    fill: "#fff"
  })));
};
export default SvgOutline;